import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom'; // Changed Redirect to useNavigate for v6
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
// import { blogPosts } from '../data/blogContent';


const BlogDetailPage = () => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBlogData = async () => {
            try {
                const response = await fetch('/blog-data.json');
                const data = await response.json();

                // 1. Find blog by slug
                const foundBlog = data.find(p => p.slug === slug);

                // 2. Security Check: Does it exist?
                if (!foundBlog) {
                    navigate('/404'); // Or redirect to blog home
                    return;
                }

                // 3. Security Check: Is it scheduled for the future?
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                const pubDate = new Date(foundBlog.publishDate);
                pubDate.setHours(0, 0, 0, 0);

                if (pubDate > today) {
                    console.warn("Access denied: Blog scheduled for future.");
                    navigate('/'); // Redirect home if trying to access future content
                    return;
                }

                // 4. Update Meta Tags for SEO (Runtime)
                document.title = `${foundBlog.metaTitle}`;
                const metaDesc = document.querySelector('meta[name="description"]');
                if (metaDesc) metaDesc.setAttribute('content', foundBlog.metaDescription);

                // 5. Inject Schema if available
                if (foundBlog.schema) {
                    const script = document.createElement('script');
                    script.type = 'application/ld+json';
                    script.id = 'blog-schema';
                    script.innerHTML = JSON.stringify(foundBlog.schema);
                    document.head.appendChild(script);
                }

                setBlog(foundBlog);
                setLoading(false);

            } catch (error) {
                console.error("Failed to fetch blog data:", error);
                setLoading(false);
            }
        };

        fetchBlogData();

        // Cleanup title & schema on unmount
        return () => {
            document.title = 'MAB Jewels (Manoj Abhushan Bhandar, Rajasthan)';
            const existingSchema = document.getElementById('blog-schema');
            if (existingSchema) existingSchema.remove();
        };
    }, [slug, navigate]);

    if (loading || !blog) {
        return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Loading...</div>;
    }

    return (
        <div className="page-container">


            <article className="blog-article" style={{ maxWidth: '800px', margin: '40px auto 80px', padding: '0 20px' }}>
                {/* Header */}
                <header style={{ textAlign: 'center', marginBottom: '50px' }}>
                    <div style={{ color: '#B8860B', fontWeight: 'bold', marginBottom: '15px', textTransform: 'uppercase', letterSpacing: '1.5px', fontSize: '0.9rem' }}>
                        {blog.category}
                    </div>
                    <h1 style={{ fontFamily: 'Playfair Display', fontSize: '2.5rem', lineHeight: '1.2', marginBottom: '20px', color: '#1a1a1a' }}>
                        {blog.title}
                    </h1>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '15px', color: '#666', fontSize: '0.95rem' }}>
                        <span>By {blog.author}</span>
                        <span>•</span>
                        <time>{new Date(blog.publishDate).toLocaleDateString('en-IN', { month: 'long', day: 'numeric', year: 'numeric' })}</time>
                    </div>
                </header>

                {/* Featured Image Placeholder */}
                {/* Featured Image */}
                <div style={{
                    width: '100%',
                    height: '400px',
                    backgroundColor: '#f5f5f5',
                    borderRadius: '16px',
                    marginBottom: '50px',
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    {blog.image ? (
                        <img
                            src={blog.image}
                            alt={blog.title}
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                    ) : (
                        <div style={{
                            width: '100%',
                            height: '100%',
                            backgroundImage: 'url(/assets/hero_bg.webp)', // Fallback from theme
                            backgroundSize: 'cover',
                            backgroundPosition: 'center'
                        }}></div>
                    )}
                </div>

                {/* Markdown Content */}
                <div className="markdown-content" style={{
                    fontSize: '1.1rem',
                    lineHeight: '1.8',
                    color: '#333',
                    fontFamily: 'serif' // Better reading experience
                }}>
                    <ReactMarkdown
                        remarkPlugins={[remarkGfm]}
                        components={{
                            table: ({ node, ...props }) => (
                                <div style={{ overflowX: 'auto', margin: '30px 0' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #eee' }} {...props} />
                                </div>
                            ),
                            thead: ({ node, ...props }) => <thead style={{ backgroundColor: '#f8f8f8' }} {...props} />,
                            th: ({ node, ...props }) => (
                                <th style={{
                                    padding: '12px 15px',
                                    textAlign: 'left',
                                    borderBottom: '2px solid #ddd',
                                    color: '#333',
                                    fontWeight: '600',
                                    border: '1px solid #eee'
                                }} {...props} />
                            ),
                            td: ({ node, ...props }) => (
                                <td style={{
                                    padding: '12px 15px',
                                    borderBottom: '1px solid #eee',
                                    color: '#555',
                                    border: '1px solid #eee'
                                }} {...props} />
                            ),
                            h2: ({ node, ...props }) => <h2 style={{ fontFamily: 'Playfair Display', marginTop: '40px', marginBottom: '20px', color: '#1a1a1a' }} {...props} />,
                            h3: ({ node, ...props }) => <h3 style={{ fontFamily: 'Playfair Display', marginTop: '30px', marginBottom: '15px', color: '#B8860B' }} {...props} />,
                            p: ({ node, ...props }) => <p style={{ marginBottom: '20px' }} {...props} />,
                            li: ({ node, ...props }) => <li style={{ marginBottom: '10px' }} {...props} />,
                            blockquote: ({ node, ...props }) => (
                                <blockquote style={{
                                    borderLeft: '4px solid #B8860B',
                                    paddingLeft: '20px',
                                    fontStyle: 'italic',
                                    margin: '30px 0',
                                    color: '#555'
                                }} {...props} />
                            ),
                            img: ({ node, ...props }) => (
                                <div style={{ display: 'flex', justifyContent: 'center', margin: '30px 0' }}>
                                    <img
                                        style={{ maxWidth: '80%', height: 'auto', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                                        {...props}
                                        alt={props.alt || 'Blog Image'}
                                    />
                                </div>
                            )
                        }}
                    >
                        {blog.content}
                    </ReactMarkdown>
                </div>

                {/* Tags */}
                <div style={{ marginTop: '60px', borderTop: '1px solid #eee', paddingTop: '30px' }}>
                    <h4 style={{ fontSize: '1rem', marginBottom: '15px' }}>Topic Tags:</h4>
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        {blog.tags.map(tag => (
                            <span key={tag} style={{
                                background: '#f5f5f5',
                                padding: '6px 14px',
                                borderRadius: '20px',
                                fontSize: '0.85rem',
                                color: '#666',
                                textTransform: 'capitalize'
                            }}>
                                #{tag}
                            </span>
                        ))}
                    </div>
                </div>

                <div style={{ marginTop: '50px', textAlign: 'center' }}>
                    <Link to="/blog" className="btn-secondary" style={{ display: 'inline-block', textDecoration: 'none' }}>
                        ← Back to Blog Journal
                    </Link>
                </div>
            </article >


        </div >
    );
};

export default BlogDetailPage;
